<template>
  <div class="login">
    <div class="loginWrap" tabindex="1" @keyup.13="login">
      <div class="loginLogo">
        <img src="../../static/images/logo1-new.png" alt="" />
      </div>
      <!-- <div class="loginBg"><img src="../../static/images/bg.png" alt=""></div> -->
      <div class="loginBox">
        <img src="../../static/images/login-logo.png" alt="" />
        <div class="loginWelcome">
          <div class="welcomeInfo">
            <img class="logo2" src="../../static/images/logo2.png" alt="" />
            <div class="welcomeh">欢迎登录睿畅连</div>
            <!-- <p class="welcomeEnglish">Welcome to the company RuiYiXing</p> -->
          </div>
          <div class="loginBody">
            <div class="loginGroup loginBottom">
              <div class="tInfo">
                <span class="inputTitle">用户</span>
                <!-- <span class="sright">ID</span> -->
              </div>
              <input
                maxlength="20"
                v-model="userName"
                @blur="sendName"
                placeholder="请输入用户名"
                class="LoginIpt"
                type="text"
              />
            </div>
            <div class="loginGroup loginBottom">
              <div class="tInfo">
                <span class="inputTitle">密码</span>
              </div>
              <input
                maxlength="20"
                :readonly="passwordReadonly"
                autocomplete="off"
                @focus="passwordReadonly = false"
                @blur="passwordReadonly = false"
                v-model="userPwd"
                placeholder="请输入密码"
                class="LoginIpt"
                :type="passwordType"
              />
              <i
                :class="[
                  'fontFamily',
                  { 'ryx-chakanmima': passwordType === 'password' },
                  { 'ryx-yincangmima': passwordType === 'text' },
                  'passWordIcon'
                ]"
                @click="passwordTypeChange"
              ></i>
            </div>
            <div class="loginGroup loginBottom validateCode">
              <div class="tInfo">
                <span class="inputTitle">验证码</span>
              </div>
              <div class="code">
                <input
                  maxlength="4"
                  @blur="pwdBlur"
                  v-model="verifyCode"
                  placeholder="请输入验证码"
                  class="codeIpt"
                  type="text"
                />
                <img :src="verifyCodeUrl" alt="" @click="getVerifyCode()" />
              </div>
            </div>
            <div class="loginRember">
              <div class="wrongTip">
                <i v-show="lerrorShow" class="fontFamily ryx-error-tips"></i>
                &nbsp;{{ wrongTip }}
              </div>
              <div class="savePwd">
                <!-- <el-checkbox v-model="savePwd">记住密码</el-checkbox> -->
                <span class="forgetPwd" @click="resetPassWord">忘记密码</span>
              </div>
            </div>
            <div class="loginIn">
              <!-- :class="{ active: loginFlag}" -->
              <!-- <div @click="login()" class="loginSub">
              登录 -->
              <!-- <img src="../../static/images/before.png" alt=""> -->
              <!-- </div> -->
              <el-button
                @click="login()"
                class="loginSub"
                type="primary"
                :loading="loading"
                >登录
              </el-button>
              <div @click="toIdm()" class="idmBtn">前往IDM登录>></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="resetPwd" v-if="false">
      <div class="resetPwdcont">
        <i class="el-icon-close" @click="cancleRestPwd"></i>
        <h2 class="title">找回密码</h2>
        <div v-show="ruleForm.type === 0">
          <p>验证码将会发送至您的注册手机</p>
          <div class="importTelNo">
            <el-form
              :inline="false"
              :rules="rules"
              :model="ruleForm"
              ref="telNo"
            >
              <el-form-item prop="telNo">
                <el-input
                  type="tel"
                  placeholder="请输入您的手机号"
                  maxlength="11"
                  v-model="ruleForm.telNo"
                  ref="telNoInput"
                ></el-input>
              </el-form-item>
            </el-form>
          </div>
        </div>

        <div v-show="ruleForm.type === 1">
          <p>请输入验证码</p>
          <div class="importTelNo">
            <el-form :inline="true" :rules="rules" :model="ruleForm" ref="code">
              <el-form-item prop="code">
                <el-input
                  type="text"
                  placeholder="验证码"
                  maxlength="6"
                  v-model="ruleForm.code"
                  ref="codeInput"
                ></el-input>
              </el-form-item>
            </el-form>
          </div>
        </div>

        <div class="importNewPwd" v-show="ruleForm.type === 2">
          <el-form
            :inline="true"
            ref="setNewPwd"
            :rules="rules"
            :model="ruleForm"
          >
            <el-form-item label="输入新密码" prop="newPwd01">
              <el-input
                type="password"
                v-model="ruleForm.newPwd01"
                maxlength="20"
              ></el-input>
            </el-form-item>
            <el-form-item label="再次输入新密码" prop="newPwd02">
              <el-input
                type="password"
                v-model="ruleForm.newPwd02"
                maxlength="20"
              ></el-input>
              <i
                class="el-icon-success"
                v-if="
                  ruleForm.newPwd01 !== '' &&
                    ruleForm.newPwd01 === ruleForm.newPwd02
                "
              ></i>
            </el-form-item>
          </el-form>
          <div class="newPwdBtn">
            <!-- <span class="save" @click="saveNewPwd">保存</span> -->
            <el-button class="save" @click="saveNewPwd" :loading="loading"
              >保存</el-button
            >
            <el-button class="cancel" @click="cancleRestPwd">取消</el-button>
            <!-- <span class="cancel" @click="cancleRestPwd">取消</span> -->
          </div>
        </div>
        <el-button
          class="nextStep"
          type="primary"
          :loading="loading"
          v-show="ruleForm.type !== 2"
          @click="nextStep"
          >下一步</el-button
        >
      </div>
    </div>
    <div v-if="projectSelectorShowed" class="project-selector-container">
      <div class="content-container">
        <p><strong>请选择项目</strong></p>
        <project-tree-input
          ref="projectTreeInput"
          v-model="selectedProjectData.projectName"
          :popoverHeight="300"
          @projectTreeDataLoaded="projectTreeDataLoaded"
          @projectTreeShowed="projectTreeShowed"
          @projectTreeHidden="projectTreeHidden"
          @projectSelected="projectSelected"
        ></project-tree-input>
        <el-button
          type="primary"
          :loading="loadingProjectList"
          :disabled="selectedProjectData.projectId === ''"
          @click="projectConfirmButtonClicked"
          >确定
        </el-button>
      </div>
    </div>
    <modify-password-dialog
      :visible.sync="isModifyPasswordDialogShowed"
      :mode="mode"
    >
    </modify-password-dialog>
    <forget-password-dialog v-if="showResetPwd" @close="showResetPwd = false">
    </forget-password-dialog>
  </div>
</template>
<script>
import ProjectTreeInput from '@/components/projectTreeInput'
import ModifyPasswordDialog from '@/components/modifyPasswordDialog'
import ForgetPasswordDialog from '@/components/forgetPasswordDialog'
import JSEncrypt from 'jsencrypt/bin/jsencrypt'
import cookie from '../utils/Tools/index'
import { publicKey } from '@/utils/password'
export default {
  name: 'login',
  components: {
    ProjectTreeInput,
    ModifyPasswordDialog,
    ForgetPasswordDialog
  },
  data () {
    return {
      loading: false,
      wrongTip: '',
      userName: '',
      passwordType: 'password',
      userPwd: '',
      verifyCode: '',
      passwordReadonly: true,
      mode: 1,
      // savePwd: false,
      lerrorShow: false,
      showResetPwd: false,
      ruleForm: {
        type: 0,
        telNo: '',
        code: '',
        newPwd01: '',
        newPwd02: '',
        oldPwd: ''
      },
      rules: {
        telNo: [
          { required: true, message: '请输入您的手机号', trigger: 'blur' },
          {
            min: 11,
            max: 11,
            message: '确认手机号码长度11位',
            trigger: 'blur'
          },
          {
            validator: (rule, value, callback) => {
              if (value.indexOf(' ') > -1) {
                callback(new Error('手机号码不能包含空格符'))
              } else if (!/^[0-9]+$/.test(value)) {
                callback(new Error('手机号码只能由数字组成！'))
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }
        ],
        code: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (value.indexOf(' ') > -1) {
                callback(new Error('验证码不能包含空格符'))
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }
        ],
        newPwd01: [
          { required: true, message: '请输入您的新密码', trigger: 'blur' },
          { min: 6, max: 20, message: '密码长度需6-20位', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (value.indexOf(' ') > -1) {
                callback(new Error('密码不能包含空格符'))
              } else {
                callback()
              }
            },
            trigger: 'blur'
          },
          {
            validator: (rule, value, c) => {
              if (!/^([_]|\w)+$/.test(this.ruleForm.newPwd01)) {
                c(new Error('密码仅支持大小写字母、数字和下划线'))
              } else {
                c()
              }
            },
            trigger: 'blur'
          }
        ],
        newPwd02: [
          { required: true, message: '请再次输入您的新密码', trigger: 'blur' },
          { min: 6, max: 20, message: '密码长度需6-20位', trigger: 'blur' },
          {
            validator: (rule, v, callback) => {
              if (v.indexOf(' ') > -1) {
                callback(new Error('密码不能包含空格符'))
              } else {
                callback()
              }
            },
            trigger: 'blur'
          },
          {
            validator: (rule, value, callback) => {
              if (!/^([_]|\w)+$/.test(this.ruleForm.newPwd02)) {
                callback(new Error('密码仅支持大小写字母、数字和下划线'))
              } else {
                callback()
              }
            },
            trigger: 'blur'
          },
          {
            validator: (rule, value, callback) => {
              if (this.ruleForm.newPwd01 !== this.ruleForm.newPwd02) {
                callback(new Error('两次输入的密码不一致，请重新输入'))
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }
        ]
      },
      userData: null,
      projectSelectorShowed: false,
      loadingProjectList: true,
      selectedProjectData: {
        projectId: '',
        projectName: '',
        selectedProjectName: ''
      },
      verifyCodeUrl: '',
      isModifyPasswordDialogShowed: false
    }
  },
  mounted () {
    // 初始化加载时若cookie中有用户名和密码则自动填充
    // let yname = localStorage.getItem('username')
    // let ypassWorld = localStorage.getItem('password')
    // this.savePwd = !!(yname && ypassWorld)
    // this.userName = yname || ''
    // this.userPwd = ypassWorld || ''
  },
  created () {
    this.getVerifyCode()
    // 获取url上的参数uid，https://easygo-stg.vanrui.com/#/login?uid=8e0d993ddb864953864f5ba42b53533b
    let uid = this.$route.query.uid
    if (uid) {
      console.log(uid)
      this.idmLogin(uid)
    }
  },
  watch: {
    'selectedProjectData.projectName': function (val) {
      if (val === '') {
        this.$refs.projectTreeInput.setTreeCurrentKey(null)
        this.selectedProjectData.projectId = ''
        this.selectedProjectData.selectedProjectName = ''
      }
      setTimeout(() => {
        this.$refs.projectTreeInput.treeFilter(val)
      }, 100)
    }
  },

  methods: {
    passwordTypeChange () {
      this.passwordType =
        this.passwordType === 'password' ? 'text' : 'password'
    },
    resetPassWord () {
      this.showResetPwd = true
    },
    nextStep () {
      let refName =
        this.ruleForm.type === 0
          ? 'telNo'
          : this.ruleForm.type === 1
            ? 'code'
            : 'setNewPwd'
      this.$refs[refName].validate(value => {
        if (value) {
          let url = ''
          let params = {
            telphone: this.ruleForm.telNo
          }
          // params.telphone = this.ruleForm.telNo
          if (this.ruleForm.type === 0) {
            url = '/user/sendmodifyCode'
          } else {
            url = '/user/checkCode'
            params.code = this.ruleForm.code
          }
          this.loading = true
          this.$https
            .get(url, params, false)
            .then(res => {
              this.loading = false
              if (res.code === 'AUTH0000' || res.code === '0') {
                if (this.ruleForm.type === 1) {
                  this.ruleForm.oldPwd = res.data
                }
                this.ruleForm.type++
              } else if (res.code === 'WX1000') {
                this.$message.error('该手机未注册睿畅连')
              } else if (res.code === 'WX2000') {
                this.$message.error('验证码过期，请重新获取验证码')
                setTimeout(() => {
                  this.ruleForm.type = 0
                  this.$refs.code.resetFields()
                }, 1000)
              } else {
                this.$message.error(res.msg)
              }
            })
            .catch(res => {
              this.loading = false
            })
        }
      })

      // this.ruleForm.type++
    },
    saveNewPwd () {
      if (
        this.ruleForm.oldPwd &&
        this.ruleForm.oldPwd === this.$md5(this.ruleForm.newPwd01)
      ) {
        this.$message.error('新密码不能与旧密码相同，请重新设置新密码')
        return
      }
      this.$refs.setNewPwd.validate(value => {
        if (value) {
          this.loading = true
          this.$https
            .post(
              '/user/updateloginPassword',
              {
                telphone: this.ruleForm.telNo,
                newPassword: this.$md5(this.ruleForm.newPwd01)
              },
              '',
              false
            )
            .then(res => {
              this.loading = false
              if (res.code === 'AUTH0000') {
                this.$message.success('密码已重置成功')
                this.showResetPwd = false
                setTimeout(() => {
                  this.ruleForm.type = 0
                  this.ruleForm.oldPwd = ''
                  this.$refs.telNo.resetFields()
                  this.$refs.codeode.resetFields()
                  this.$refs.setNewPwd.resetFields()
                }, 1000)
              } else {
                if (res.code === 'WX2000') {
                  this.$message.error('验证已失效，请重新获取验证码')
                  this.$refs.code.resetFields()
                  this.ruleForm.oldPwd = ''
                  // this.ruleForm.code = ''
                  // this.ruleForm.newPwd01 = ''
                  // this.ruleForm.newPwd02 = ''
                  setTimeout(() => {
                    this.ruleForm.type = 0
                    this.$refs.setNewPwd.resetFields()
                  }, 1000)
                } else {
                  this.$message.error(res.msg)
                }
              }
            })
            .catch(res => {
              this.loading = false
            })
        }
      })
    },
    cancleRestPwd () {
      this.showResetPwd = false
      this.ruleForm.type = 0
      this.ruleForm.oldPwd = ''
      this.$refs.telNo.resetFields()
      this.$refs.code.resetFields()
    },
    // 用户名失焦验证
    sendName () {
      let engReg = /[a-zA-Z]/
      let numReg = /[0-9]/
      let underlineReg = /[_]/
      let specialCharsReg = /[~'!@#￥$%^&*()-+=:]/
      if (this.userName === '') {
        this.wrongTip = '用户名不能为空'
        return false
      } else if (
        !engReg.test(this.userName) &&
        !numReg.test(this.userName) &&
        !underlineReg.test(this.userName)
      ) {
        this.wrongTip = '用户名只支持大小写字母、数字、下划线的组合'
        return false
      } else if (specialCharsReg.test(this.userName)) {
        this.wrongTip = '用户名不能输入特殊字符'
        return false
      } else if (this.userName.indexOf(' ') >= 0) {
        this.wrongTip = '用户名不能包含空格'
        return false
      } else {
        this.wrongTip = ''
      }
    },
    // 密码获取焦点时登录按钮变色
    pwdBlur () {
      if (this.userName !== undefined && this.userPwd.length !== 0) {
        this.loginFlag = true
        this.lerrorShow = false
        this.wrongTip = ''
      } else if (this.userPwd.length === 0) {
        this.loginFlag = false
      } else {
        // sonar规则校验语法必须else
      }
    },
    toIdm () {
      // 获取当前环境
      let host = location.host
      if (host.includes('stg')) {
        location.href =
          'https://api-easygo-stg.vanrui.com/web/portal/user/idm/login'
      } else {
        location.href =
          'https://api-easygo.vanrui.com/web/portal/user/idm/login'
      }
    },
    // 登录
    login () {
      let lpwdPatern = /[a-zA-Z]|\w/
      if (this.userName === '') {
        this.lerrorShow = true
        this.wrongTip = '用户名不能为空'
        return false
      } else if (this.userPwd === '') {
        this.lerrorShow = true
        this.wrongTip = '密码不能为空'
        return false
      } else if (
        !lpwdPatern.test(this.userPwd) ||
        this.userPwd.indexOf(' ') >= 0
      ) {
        this.lerrorShow = true
        this.wrongTip = '密码错误'
        return false
      } else if (this.verifyCode === '') {
        this.lerrorShow = true
        this.wrongTip = '请输入验证码'
        return false
      } else {
        this.lerrorShow = false
        this.wrongTip = ''
      }

      // // 登录时若勾选记住密码则保存cookie
      // if (this.savePwd === true) {
      //   localStorage.setItem('username', this.userName)
      //   localStorage.setItem('password', this.userPwd)
      // } else {
      //   localStorage.removeItem('username')
      //   localStorage.removeItem('password')
      // }
      // let md5pwd = this.$md5(this.userPwd)
      const jse = new JSEncrypt()
      jse.setPublicKey(publicKey) // 配置公钥
      let password = jse.encrypt(this.userPwd) // 加密密码

      this.loading = true
      this.$https
        .post(
          'user/login',
          {
            userName: this.userName,
            password,
            code: this.verifyCode
          },
          '',
          false
        )
        .then(res => {
          this.loading = false
          let userData = null
          if (res.code === '500') {
            this.lerrorShow = true
            this.wrongTip = res.msg
            this.getVerifyCode()
            this.verifyCode = ''
          } else if (res.code === '400') {
            this.lerrorShow = true
            this.wrongTip = '账号已冻结，请求管理员解冻账号'
            this.getVerifyCode()
            this.verifyCode = ''
          } else if (res.code === 'WX4000') {
            this.lerrorShow = true
            this.wrongTip = '验证码错误'
            this.getVerifyCode()
            this.verifyCode = ''
          } else {
            if (res.data) {
              userData = res.data.id ? res.data : res.data[0]
              userData &&
                userData.userName &&
                sessionStorage.setItem('user_name', userData.userName)
            }
            if (res.code === '100') {
              sessionStorage.setItem('user_name', this.userName)
              this.isModifyPasswordDialogShowed = true
              this.mode = 1
              this.verifyCode = ''
              this.getVerifyCode()
              return
            }
            if (
              res.data.overDays &&
              res.data.overDays > 0 &&
              res.data.overDays <= 15
            ) {
              this.$message.warning(
                `您的密码将于${res.data.overDays}天后过期，请及时修改密码。`
              )
            } else if (res.data.overDays !== null && res.data.overDays <= 0) {
              this.isModifyPasswordDialogShowed = true
              this.mode = 2
              this.verifyCode = ''
              this.getVerifyCode()
              return
            } else {
              // sonar规则校验语法必须else
            }

            this.lerrorShow = false
            this.wrongTip = ''
            cookie.setCookie('user_name', userData.userName) // 将token值存在本地
            sessionStorage.setItem('E-User-Token', res.code) // 将token值存在本地
            cookie.setCookie('UserId', userData.id) // 将userId值存在本地
            sessionStorage.setItem('UserId', userData.id) // 将userId值存在本地
            cookie.setCookie('companyId', userData.companyId) // 将companyId值存在本地
            sessionStorage.setItem('companyId', userData.companyId) // 将companyId值存在本地
            sessionStorage.setItem('telphone', userData.telphone)
            localStorage.setItem('telphone', userData.telphone)
            // 设置userId值到Vuex
            this.$store.commit('setUserId', userData.id)
            // 跳转到人员列表页面
            this.$store.commit('SET_USER', userData)
            if (
              userData.isAdmin ||
              localStorage.getItem('selectedProject_' + userData.id)
            ) {
              this.$router.push({ name: 'main' })
            } else {
              this.userData = userData
              this.projectSelectorShowed = true
            }
            cookie.setCookie('nickName', userData.nickName)
          }
        })
        .catch(() => {
          this.loading = false
          console.log('登录错误')
        })
      /* this.$https.post('role/list?user_id=' + 1).then((res) => {
              console.log(res.data);
            }); */
      // this.$router.push({path: '/addressmgr'});
    },
    idmLogin (uid) {
      this.$https
        .get('/user/idm/userInfo', { uid }, false)
        .then(res => {
          // this.loading = false
          let userData = null
          if (res.code === '500') {
            // this.lerrorShow = true
            // this.wrongTip = res.msg
            // this.getVerifyCode()
            // this.verifyCode = ''
            this.$message.warning(res.msg)
          } else if (res.code === '400') {
            this.$message.warning('账号已冻结，请求管理员解冻账号')
            // this.lerrorShow = true
            // this.wrongTip = '账号已冻结，请求管理员解冻账号'
            // this.getVerifyCode()
            // this.verifyCode = ''
          } else if (res.code === 'WX4000') {
            // this.lerrorShow = true
            // this.wrongTip = '验证码错误'
            // this.getVerifyCode()
            // this.verifyCode = ''
          } else {
            if (res.data) {
              userData = res.data.id ? res.data : res.data[0]
              userData &&
                userData.userName &&
                sessionStorage.setItem('user_name', userData.userName)
            }
            if (res.code === '100') {
              // sessionStorage.setItem('user_name', this.userName)
              // this.isModifyPasswordDialogShowed = true
              // this.mode = 1
              // this.verifyCode = ''
              // this.getVerifyCode()
              // return
            }
            if (
              res.data.overDays &&
              res.data.overDays > 0 &&
              res.data.overDays <= 15
            ) {
              // this.$message.warning('账号已过期，请联系管理员')
              // this.$message.warning(
              //   `您的密码将于${res.data.overDays}天后过期，请及时修改密码。`
              // )

            } else if (res.data.overDays !== null && res.data.overDays <= 0) {
              this.$message.warning('账号已过期，请联系管理员')
              return
            } else {
              // sonar规则校验语法必须else
            }

            this.lerrorShow = false
            this.wrongTip = ''
            cookie.setCookie('user_name', userData.userName) // 将token值存在本地
            sessionStorage.setItem('E-User-Token', res.code) // 将token值存在本地
            cookie.setCookie('UserId', userData.id) // 将userId值存在本地
            sessionStorage.setItem('UserId', userData.id) // 将userId值存在本地
            cookie.setCookie('companyId', userData.companyId) // 将companyId值存在本地
            sessionStorage.setItem('companyId', userData.companyId) // 将companyId值存在本地
            sessionStorage.setItem('telphone', userData.telphone)
            localStorage.setItem('telphone', userData.telphone)
            // 设置userId值到Vuex
            this.$store.commit('setUserId', userData.id)
            // 跳转到人员列表页面
            this.$store.commit('SET_USER', userData)
            if (
              userData.isAdmin ||
              localStorage.getItem('selectedProject_' + userData.id)
            ) {
              this.$router.push({ name: 'main' })
            } else {
              this.userData = userData
              this.projectSelectorShowed = true
            }
            cookie.setCookie('nickName', userData.nickName)
          }
        })
        // .then(res => {
        //   if(!res.code){
        //     this.$message.warning("账号已过期，请联系管理员")
        //     return
        //   }
        //   //
        //   let userData = null
        //   if (res.data && res.msg === '登录成功') {
        //     if (res.data) {
        //       userData = res.data.id ? res.data : res.data[0]
        //       userData &&
        //         userData.userName &&
        //         sessionStorage.setItem('user_name', userData.userName)
        //     }

        //     cookie.setCookie('user_name', userData.userName) // 将token值存在本地
        //     sessionStorage.setItem('E-User-Token', res.code) // 将token值存在本地
        //     cookie.setCookie('UserId', userData.id) // 将userId值存在本地
        //     sessionStorage.setItem('UserId', userData.id) // 将userId值存在本地
        //     cookie.setCookie('companyId', userData.companyId) // 将companyId值存在本地
        //     sessionStorage.setItem('companyId', userData.companyId) // 将companyId值存在本地
        //     sessionStorage.setItem('telphone', userData.telphone)
        //     // 设置userId值到Vuex
        //     this.$store.commit('setUserId', userData.id)
        //     // 跳转到人员列表页面
        //     this.$store.commit('SET_USER', userData)
        //     if (
        //       userData.isAdmin ||
        //       localStorage.getItem('selectedProject_' + userData.id)
        //     ) {
        //       this.$router.push({ name: 'main' })
        //     } else {
        //       this.userData = userData
        //       this.projectSelectorShowed = true
        //     }
        //     cookie.setCookie('nickName', userData.nickName)
        //   } else {
        //     this.$message.warning(res.msg)
        //     setTimeout(() => {
        //       this.reloadPage()
        //     }, 1500)
        //   }
        //   // --------------------------------------------
        //   // this.loading = false
        //   // let userData = null
        //   // if (res.code === '500') {
        //   //   this.$message.warning(res.msg)
        //   // } else if (res.code === '400') {
        //   //   this.$message.warning(`账号已冻结，请求管理员解冻账号`)
        //   // } else {
        //   //   if (res.data) {
        //   //     userData = res.data.id ? res.data : res.data[0]
        //   //     userData &&
        //   //       userData.userName &&
        //   //       sessionStorage.setItem('user_name', userData.userName)
        //   //   }

        //   //   cookie.setCookie('user_name', userData.userName) // 将token值存在本地
        //   //   sessionStorage.setItem('E-User-Token', res.code) // 将token值存在本地
        //   //   cookie.setCookie('UserId', userData.id) // 将userId值存在本地
        //   //   sessionStorage.setItem('UserId', userData.id) // 将userId值存在本地
        //   //   cookie.setCookie('companyId', userData.companyId) // 将companyId值存在本地
        //   //   sessionStorage.setItem('companyId', userData.companyId) // 将companyId值存在本地
        //   //   sessionStorage.setItem('telphone', userData.telphone)
        //   //   // 设置userId值到Vuex
        //   //   this.$store.commit('setUserId', userData.id)
        //   //   // 跳转到人员列表页面
        //   //   this.$store.commit('SET_USER', userData)
        //   //   if (
        //   //     userData.isAdmin ||
        //   //     localStorage.getItem('selectedProject_' + userData.id)
        //   //   ) {
        //   //     this.$router.push({ name: 'main' })
        //   //   } else {
        //   //     this.userData = userData
        //   //     this.projectSelectorShowed = true
        //   //   }
        //   //   cookie.setCookie('nickName', userData.nickName)
        //   // }
        // })
        .catch((err) => {
          console.log('登录错误')
          this.$message.warning(err.msg || '登录错误')
          setTimeout(() => {
            this.reloadPage()
          }, 1500)
        })
    },
    reloadPage () {
      let host = location.host
      if (host.includes('stg')) {
        location.href =
              'https://easygo-stg.vanrui.com/#/login'
      } else {
        location.href = 'https://easygo.vanrui.com/#/login'
      }
    },
    projectTreeDataLoaded (val) {
      this.loadingProjectList = false
    },
    projectTreeShowed () {
      setTimeout(() => {
        this.$refs.projectTreeInput.treeFilter('')
      }, 100)
    },
    projectTreeHidden () {
      this.selectedProjectData.projectName = this.selectedProjectData.selectedProjectName
    },
    projectSelected (val, isAutoSelected) {
      if (val.projectCode) {
        this.selectedProjectData.projectId = val.id
        this.selectedProjectData.projectName = val.name
        this.selectedProjectData.selectedProjectName = val.name
        if (!isAutoSelected) {
          this.$refs.projectTreeInput.hideProjectTree()
        } else {
          this.projectConfirmButtonClicked()
        }
      }
    },
    projectConfirmButtonClicked () {
      localStorage.setItem(
        'selectedProject_' + this.userData.id,
        this.selectedProjectData.projectId
      )
      this.$router.push({ name: 'main' })
    },
    async getVerifyCode () {
      try {
        let res = await this.$https.axios({
          method: 'get',
          url: 'user/getVerifyCode'
        })
        this.verifyCodeUrl = 'data:image/jpg;base64,' + res.data.imageData
      } catch (e) {
        console.log(e)
      }
    }
  }
}
</script>
<style lang="less">
@spaceName: login;
.@{spaceName} {
  .el-checkbox__input.is-checked .el-checkbox__inner {
    background-color: #feb938 !important;
    border-color: #feb938 !important;
  }
  .el-checkbox__inner:hover {
    border-color: #feb938 !important;
  }
  .el-checkbox__input.is-focus .el-checkbox__inner {
    border-color: #feb938 !important;
  }
  .el-checkbox__input.is-checked + .el-checkbox__label {
    color: #708daf;
  }
  .passWordIcon {
    position: absolute;
    right: 0;
    cursor: pointer;
    top: 60px;
  }
  .loginWrap {
    width: 100%;
    height: 100%;
    background-color: #e5eeff;
    z-index: 99;
    position: absolute;
    top: 0;
    left: 0;
    background-image: url(../../static/images/login-backgounrd.png);
    background-repeat: no-repeat;
    background-size: auto;
    background-position: center;
    .loginLogo {
      width: 154px;
      height: 63px;
      position: absolute;
      top: 36px;
      left: 48px;
    }
    .loginBg {
      width: 75%;
      height: auto;
      position: absolute;
      bottom: 0;
      left: 0;
    }
    .loginBox {
      position: absolute;
      top: 50%;
      left: 50%;
      height: auto;
      width: 100%;
      text-align: center;
      transform: translate(-50%, -50%);
      /*box-shadow: 0 0 5px #d4e2f7;*/
      /*-webkit-box-shadow: #b3c3e4 0px 0px 50px;*/
      /*-moz-box-shadow: #b3c3e4 0px 0px 50px;*/
      /*box-shadow: #b3c3e4 0px 0px 50px;*/
      > * {
        display: inline-block;
        vertical-align: middle;
      }
      .loginWelcome {
        margin-left: 80px;
        background-color: #ffffff;
        border-radius: 36px;
        box-shadow: #b3c3e4 0px 0px 50px;
      }
      .welcomeInfo {
        height: 120px;
        width: 360px;
        background-color: #78a6fe;
        border-top-left-radius: 36px;
        border-top-right-radius: 36px;
        padding-top: 36px;
        position: relative;
        .logo2 {
          width: 72px;
          height: auto;
          position: absolute;
          top: 36px;
          left: 0;
        }
        .welcomeh {
          color: #ffffff;
          height: 36px;
          line-height: 36px;
          text-align: center;
          font-size: 20px;
        }
        .welcomeEnglish {
          color: #eaeaea;
          height: 36px;
          line-height: 36px;
          text-align: center;
          font-size: 15px;
        }
      }
      .loginBody {
        height: auto;
        padding-left: 24px;
        padding-right: 24px;
        width: 360px;
        .loginBottom {
          border-bottom: 1px solid #dadada;
          position: relative;
        }
        .loginGroup {
          height: 96px;
          .code {
            overflow: hidden;
            img {
              width: 100px;
              height: 42px;
              background-color: #f2f2f2;
              float: right;
            }
            input {
              font-size: 18px;
              float: left;
              width: 67%;
            }
          }
          .tInfo {
            height: 48px;
            line-height: 48px;
            width: 100%;
            text-align: center;
            color: #738daf;
            position: relative;
            .inputTitle {
              font-size: 18px;
            }
            .sright {
              position: absolute;
              right: 0;
              font-size: 19px;
              color: #a6b6d5;
            }
          }
          .LoginIpt,
          .codeIpt {
            height: 47px;
            line-height: 47px;
            text-align: center;
            outline: none;
            border: 0;
          }
          .LoginIpt {
            width: 100%;
          }
          > input {
            font-size: 18px;
          }
        }
        .loginRember {
          height: 72px;
          .wrongTip {
            height: 24px;
            line-height: 24px;
            text-align: center;
            color: #ff7474;
          }
          .savePwd {
            height: 36px;
            line-height: 36px;
            text-align: center;
            .forgetPwd {
              font-size: 14px;
              color: #78a6fe;
              margin-left: 30px;
              cursor: pointer;
            }
          }
        }
        .loginIn {
          height: 100px;
          .loginSub {
            font-size: 16px;
            height: 48px;
            // background-color: rgba(120,166,255,0.5);
            background-color: #78a6fe;
            border-color: #78a6fe;
            text-align: center;
            color: #ffffff;
            border-radius: 10px;
            width: 100%;
          }
          .active {
            background-color: rgba(120, 166, 255, 1);
          }
        }
        .idmBtn {
          display: inline-block;
          font-size: 16px;
          padding: 8px 0;
          cursor: pointer;
        }
      }
    }
  }
  .resetPwd {
    position: relative;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    z-index: 111;
    .resetPwdcont {
      width: 500px;
      height: 360px;
      background-color: #ffffff;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      margin: auto;
      z-index: 112;
      border-radius: 4px;
      padding: 40px 60px;
      .el-icon-close {
        font-size: 18px;
        position: absolute;
        top: 16px;
        right: 16px;
        cursor: pointer;
      }
      h2 {
        font-size: 22px;
        margin-bottom: 4px;
      }
      p {
        color: #999;
        font-size: 16px;
        line-height: 26px;
      }
      .importTelNo {
        margin-top: 42px;
        border-bottom: 1px solid #dddddd;
        input {
          height: 32px;
          width: 100%;
          margin-bottom: 4px;
          border: none;
          appearance: none;
          padding: 0;
          font-size: 16px;
        }
        .el-form-item {
          .el-form-item__content {
            width: 100%;
          }
          margin-bottom: 0;
          width: 100%;
        }
        .el-form-item__error {
          margin-top: 4px;
        }
      }
      .nextStep {
        width: 100%;
        height: 48px;
        background-color: #78a6fe;
        color: #ffffff;
        text-align: center;
        // line-height: 48px;
        margin-top: 80px;
        border-radius: 4px;
        font-size: 16px;
        cursor: pointer;
      }
      .importNewPwd {
        margin-top: 30px;
        .el-icon-success {
          position: absolute;
          color: #67c23a;
          right: -25px;
          top: 15px;
        }
        .el-form-item__label {
          display: inline-block;
          font-size: 15px;
          width: 130px;
        }
        .newPwdBtn {
          text-align: center;
          margin-top: 36px;
          button {
            display: inline-block;
            width: 96px;
            height: 42px;
            text-align: center;
            font-size: 16px;
            border: 1px solid;
            cursor: pointer;
            border-radius: 2px;
            &.save {
              background-color: #78a6fe;
              color: #ffffff;
              border-color: #78a6fe;
              margin-right: 16px;
            }
            &.cancel {
              background-color: #ffffff;
              color: #78a6fe;
              border-color: #dadada;
            }
          }
        }
      }
    }
    .el-form--inline .el-form-item__content {
      width: 220px;
    }
  }
  > .project-selector-container {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 100;
    background-color: rgba(0, 0, 0, 0.6);
    > .content-container {
      position: absolute;
      top: 50%;
      left: 50%;
      padding: 18px 18px;
      border-radius: 5px;
      transform: translate(-50%, -50%);
      background-color: #ffffff;
      > p {
        margin-bottom: 10px;
        font-size: 16px;
        text-align: center;
      }
      > button {
        display: block;
        margin: 10px auto auto;
        &.el-button--primary {
          background-color: #6e9dd3;
          border-color: #6e9dd3;
          &.is-disabled {
            background-color: #7a7a7a;
            border-color: #7a7a7a;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/login.vue